import { render, staticRenderFns } from "./Cornice.vue?vue&type=template&id=27bc433c&"
import script from "./Cornice.vue?vue&type=script&lang=js&"
export * from "./Cornice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports